import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Newsletter from '../components/Newsletter';
import { Link, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronRight,
  faCalendarAlt,
  faUser,
  faSpinner,
} from "@fortawesome/free-solid-svg-icons";
import { getBlogBySlug, getBlogImageUrl } from '../services/blogService';

export default function BlogDetail() {
  const { slug }          = useParams();
  const [blog, setBlog]   = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState(null);

  useEffect(() => {
    const fetchBlog = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await getBlogBySlug(slug);
        setBlog(data);
      } catch (err) {
        setError(err.message || 'Blog not found.');
      } finally {
        setLoading(false);
      }
    };
    fetchBlog();
    window.scrollTo(0, 0);
  }, [slug]);

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    return d.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
  };

  return (
    <>
      <Header />

      <section className="breadcrumbsection">
        <div className='container'>
          <h1>{loading ? 'Blog' : (blog?.title || 'Blog Detail')}</h1>
          <ul className='breadcrumblinks'>
            <li><Link to="/">Home</Link></li>
            <li><FontAwesomeIcon icon={faChevronRight} /></li>
            <li><Link to="/blogs">Blogs</Link></li>
            <li><FontAwesomeIcon icon={faChevronRight} /></li>
            <li>{loading ? '...' : (blog?.title || 'Detail')}</li>
          </ul>
        </div>
      </section>

      <section className="blog-detail-section">
        <div className="container">

          {/* Loading */}
          {loading && (
            <div className="blogs-loading">
              <FontAwesomeIcon icon={faSpinner} spin className="blogs-spinner" />
              <p>Loading article...</p>
            </div>
          )}

          {/* Error */}
          {!loading && error && (
            <div className="blogs-error">
              <p>{error}</p>
              <Link to="/blogs" className="btn btn-primary mt-3">Back to Blogs</Link>
            </div>
          )}

          {/* Blog Content */}
          {!loading && !error && blog && (
            <div className="blog-detail-wrapper">

              {/* Hero Image */}
              <div className="blog-detail-hero">
                <img
                  src={getBlogImageUrl(blog.image)}
                  alt={blog.title}
                  className="blog-detail-hero-img"
                  onError={(e) => { e.target.src = '/images/service1.png'; }}
                />
              </div>

              {/* Meta */}
              <div className="blog-detail-meta">
                <div className="blog-meta-item">
                  <FontAwesomeIcon icon={faCalendarAlt} />
                  <span>{formatDate(blog.blog_date)}</span>
                </div>
                <div className="blog-meta-divider"></div>
                <div className="blog-meta-item">
                  <FontAwesomeIcon icon={faUser} />
                  <span>{blog.author}</span>
                </div>
              </div>

              {/* Title */}
              <h1 className="blog-detail-title">{blog.title}</h1>

              {/* Excerpt */}
              {blog.excerpt && (
                <p className="blog-detail-excerpt">{blog.excerpt}</p>
              )}

              {/* Divider */}
              <div className="blog-detail-divider"></div>

              {/* Content — rendered as HTML */}
              <div
                className="blog-detail-content"
                dangerouslySetInnerHTML={{ __html: blog.content }}
              />

              {/* Back Link */}
              <div className="blog-detail-back">
                <Link to="/blogs" className="blog-back-btn">
                  &larr; Back to All Articles
                </Link>
              </div>

            </div>
          )}
        </div>
      </section>

      <Newsletter />
      <Footer />
    </>
  );
}